import makeSlice from '@web/slices/waiting/sliceMaker'

const slice = makeSlice()

export default slice.reducer
